import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NativeHostPushNotifications" */ './lazyIndex'),
    { name: 'NativeHostPushNotifications' }
);

export const lazyUnsubscribeToNativePushNotificationForAllAccounts: LazyAction<
    typeof lazyIndex.unsubscribeToNativePushNotificationForAllAccounts,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.unsubscribeToNativePushNotificationForAllAccounts);

export const lazyUnsubscribeToNativePushNotification: LazyAction<
    typeof lazyIndex.unsubscribeToNativePushNotification,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.unsubscribeToNativePushNotification);
